export default "__VITE_ASSET__BhAMwaOn__"